module.exports = __webpack_public_path__ + "static/media/chevronup.a8abefd6.svg";